export const fileColumns: { [key: string]: string } = {
    id: "Id",
    personId: "Person ID",
    identificationNumber: "No Identificación",
    nameUN: "Empresa",
    nameUP: "Finca",
    fullName: "Nombre",
    jobTitle: "Cargo",
    eMail: "Correo",
    phone: "Teléfono",
    surveyLastUpdate: "Ultima actualización",
    noSurvey: "Número de encuestas",
    completedSurvey: "Fecha encuesta completada",
    position: "Página completada",
    surveyStatus: "Estado encuesta",
    percentage: "Porcentaje completado",
    sentByEMail: "Enviada por correo",
    sentBySMS: "Enviada por sms",
    expiredToken: "Expiró el Token",
    temporaryCompany: "Empresa Temporal",
    idLugarTrabajo: "ID Lugar de Trabajo",
    lugarTrabajo: "Lugar de Trabajo",
    idCentroCosto: "ID Centro de Costos",
    centroCosto: "Centro de Costos"
  };